// extracted by mini-css-extract-plugin
export default {"selfReflection":"styles__selfReflection___ntMPm"};